const ARTICLE_ADMIN_CENTER_OVERVIEW = 'admin_center_overview'
const ARTICLE_ANALYTICS_OVERVIEW = 'analytics_overview'
const ARTICLE_ANALYTICS_OVERVIEW_CAPACITY = 'analytics_overview_capacity'
const ARTICLE_ANALYTICS_OVERVIEW_ROUTING = 'analytics_overview_routing'
const ARTICLE_CONTACTS_OVERVIEW = 'contacts_overview'
const ARTICLE_EVENT_TYPES_OVERVIEW = 'event_types_overview'
const ARTICLE_GROUPS_OVERVIEW = 'groups_overview'
const ARTICLE_MANAGED_EVENTS_OVERVIEW = 'managed_events_overview'
const ARTICLE_MANAGED_WORKFLOWS_OVERVIEW = 'managed_workflows_overview'
const ARTICLE_MEETINGS_OVERVIEW = 'meetings_overview'
const ARTICLE_ROUTING_OVERVIEW = 'routing_overview'
const ARTICLE_ADDING_USERS_OVERVIEW = 'adding_users_overview'
const ARTICLE_WORKFLOWS_OVERVIEW = 'workflows_overview'
const ARTICLE_RECAPS_SETUP = 'recaps_setup'
// const ARTICLE_RECAPS_SHARE = 'recaps_share'
const ARTICLE_SCHEDULING_OVERVIEW = 'scheduling_overview'
const ARTICLE_MEETING_TYPES_OVERVIEW = 'meeting_types_overview'
const ARTICLE_SINGLE_USE_LINKS_OVERVIEW = 'single_use_links_overview'
const ARTICLE_POLLS_OVERVIEW = 'polls_overview'
const ARTICLE_BLOCKED_SOURCES_OVERVIEW = 'blocked_sources_overview'

export const ARTICLE_CONTENT_KEYS = {
  ADDING_USERS: ARTICLE_ADDING_USERS_OVERVIEW,
  ADMIN_CENTER: ARTICLE_ADMIN_CENTER_OVERVIEW,
  ANALYTICS: ARTICLE_ANALYTICS_OVERVIEW,
  ANALYTICS_CAPACITY: ARTICLE_ANALYTICS_OVERVIEW_CAPACITY,
  ANALYTICS_ROUTING: ARTICLE_ANALYTICS_OVERVIEW_ROUTING,
  CONTACTS: ARTICLE_CONTACTS_OVERVIEW,
  EVENT_TYPES: ARTICLE_EVENT_TYPES_OVERVIEW,
  GROUPS: ARTICLE_GROUPS_OVERVIEW,
  MANAGED_EVENTS: ARTICLE_MANAGED_EVENTS_OVERVIEW,
  MANAGED_WORKFLOWS: ARTICLE_MANAGED_WORKFLOWS_OVERVIEW,
  MEETINGS: ARTICLE_MEETINGS_OVERVIEW,
  ROUTING: ARTICLE_ROUTING_OVERVIEW,
  WORKFLOWS: ARTICLE_WORKFLOWS_OVERVIEW,
  RECAPS_SETUP: ARTICLE_RECAPS_SETUP,
  // RECAPS_SHARE: ARTICLE_RECAPS_SHARE,
  SCHEDULING: ARTICLE_SCHEDULING_OVERVIEW,
  MEETING_TYPES: ARTICLE_MEETING_TYPES_OVERVIEW,
  SINGLE_USE_LINKS: ARTICLE_SINGLE_USE_LINKS_OVERVIEW,
  POLLS: ARTICLE_POLLS_OVERVIEW,
  BLOCKED_SOURCES: ARTICLE_BLOCKED_SOURCES_OVERVIEW,
}
